/** @fileoverview Renders tenant access and Fabrik billing status states. */

import { LockKeyhole } from 'lucide-react';
import LoadingState from '../ui/loading-state';

export function FabrikAccessDenied() {
  return (
    <main className="flex min-h-0 flex-1 items-center justify-center bg-app-surface-muted px-6">
      <section className="max-w-md text-center">
        <LockKeyhole className="mx-auto h-12 w-12 text-app-text-muted" aria-hidden="true" />
        <h1 className="mt-5 text-2xl font-bold text-app-text">You do not have access</h1>
        <p className="mt-3 text-sm leading-6 text-app-text-muted">
          You may have selected the wrong workspace, or you do not have access to this app. Try
          switching workspaces from the menu at the top.
        </p>
        <p className="mt-4 text-sm text-app-text-muted">
          Stuck? Reach out to us at{' '}
          <a className="font-semibold text-app-action underline" href="mailto:support@integrtr.com">
            support@integrtr.com
          </a>
          .
        </p>
      </section>
    </main>
  );
}

export function FabrikBillingBlocked({ checking, failed }: { checking: boolean; failed: boolean }) {
  return (
    <main className="flex min-h-0 flex-1 items-center justify-center bg-app-surface-muted px-6">
      {checking ? (
        <LoadingState>
          <span className="font-semibold text-app-text">Checking workspace access</span>
          <span>Please wait while we verify access to this workspace.</span>
        </LoadingState>
      ) : (
        <section className="max-w-md text-center">
          <LockKeyhole className="mx-auto h-12 w-12 text-app-text-muted" aria-hidden="true" />
          <h1 className="mt-5 text-2xl font-bold text-app-text">
            {failed ? 'We could not check access' : 'No usage plan for this workspace'}
          </h1>
          <p className="mt-3 text-sm leading-6 text-app-text-muted">
            {failed
              ? 'We could not verify access to this workspace. Please try again later.'
              : 'This workspace has no plan assigned yet, so Fabrik cannot be used here.'}
          </p>
          <p className="mt-4 text-sm text-app-text-muted">
            Please reach out to us at{' '}
            <a
              className="font-semibold text-app-action underline"
              href="mailto:support@integrtr.com"
            >
              support@integrtr.com
            </a>{' '}
            to get a plan assigned
          </p>
        </section>
      )}
    </main>
  );
}
